import AdvanceSettingStyle from './AdvanceSetting.module.css'
import renderImage from '../../source/importImg'
import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import packageJson from '../../../package.json'
import MainHeader from '../ReusableComponents/Header/MainHeader'
// import { getS3Version } from '../ReusableComponents/ByteTransfer/getVersion'
import { connect } from 'react-redux'
import { getLegalInfo, getBrand, getLogo } from '../../hooks/useBrandConfig'
import {
    getWebAgentVersion,
    getAssetsVersion,
} from '../../utils/versionHelpers'

import { getDeviceName } from '../../utils/utils'

const FIRMWARE_PREFIX_TO_DEVICE = {
    CW: 'Hexapod',
    ZG: 'Humanoid',
    RB: 'Roboki',
    KW: 'Klaw',
    PCv: 'Ace',
    PC: 'Ace',
    AT: 'Atr',
    TK: 'Toki',
    PK: 'Poki',
    MK: 'Moki',
    AK: 'Autoki',
}

function AboutApplication(props) {
    let history = useHistory()
    const [isHelp, setHelp] = useState(false)
    const [firmwareVersion, setFirmwareVersion] = useState('')
    const [webAgentVersion, setWebAgentVersion] = useState(null)
    const [assetsVersion, setAssetsVersion] = useState(null)
    // const [deviceName, setdeviceName] = useState('')
    const isConnectRef = useRef(props.isConnected)
    const versionRef = useRef(false)

    const grtDeviceName = (firmwareVersion) => {
        try {
            let result = firmwareVersion.match(/^([A-Za-z_]+)v?([\d.]+)/)
            if (result) {
                if (result[1] === 'ZGMP_')
                    return `${getDeviceName('Humanoid')}/${getDeviceName('Hexapod')}`
                return getDeviceName(
                    FIRMWARE_PREFIX_TO_DEVICE[result[1]] || 'Ace'
                )
            } else return ''
        } catch (e) {
            console.log('ERROR', e)
            return ''
        }
    }

    const getDeviceVersion = (version) => {
        if (version.includes('PCMP') || version.includes('ZGMP')) {
            return 'MICROPYTHON'
        }

        // Optional trailing segment so a 4-part hotfix version (e.g. RB1.1.7.1) matches in full instead of being cut to 3 parts.
        let regx =
            /(?:(PCv1\.\d{1,3}\.\d{2}[ab]?)|((PCv0\.1\.\d{2}))|((?:ZG|CW|KW|PC|AT|TK|MK|AK)[0,1,2]\.\d{1,3}\.\d{1,3}(?:\.\d{1,3})?)|RB\d{1}(\.\d{1,3}){2}(?:\.\d{1,3})?|((ZG|PC)MP_[0-9]\.[0-9]))/
        let match = version.match(regx)
        if (match) {
            let newVersion = match[0].replace(/^[a-zA-Z]+/, '')
            return newVersion
        }
        return version
    }

    useEffect(() => {
        const getVersion = async () => {
            while (true) {
                if (isConnectRef.current && !versionRef.current) {
                    props.worker.postMessage({
                        type: 'write',
                        value: 'WHO',
                    })
                    await new Promise((reslove) => setTimeout(reslove, 300))
                } else {
                    versionRef.current = false
                    break
                }
            }
        }
        if (props.isConnected) {
            isConnectRef.current = true
            getVersion()
        } else {
            isConnectRef.current = false
        }
    }, [props.isConnected])

    useEffect(() => {
        const messageHandel = (e) => {
            if (e.data.type === 'read') {
                const garbageRemovalRegex = /[\u0000\x00]+|[^a-zA-Z0-9_.v]+/g ///[\u0000\x00]+/g
                const cleanedVersion = e.data.value.replace(
                    garbageRemovalRegex,
                    ''
                )
                // let match = cleanedVersion.match(/^([A-Za-z]+)v?([\d.]+)/)

                // console.log('VVVVVV', match)
                // if (match) {
                const allowedPrefixes = [
                    'CW',
                    'ZG',
                    'RB',
                    'KW',
                    'PCv',
                    'PC',
                    'AT',
                    'TK',
                    'MK',
                    'AK',
                    'PK',
                ]

                const isValidPrefix = allowedPrefixes.some((allowed) =>
                    cleanedVersion.startsWith(allowed)
                )
                if (isValidPrefix) {
                    setFirmwareVersion(cleanedVersion)
                    versionRef.current = true
                }
            }
        }
        props.worker.addEventListener('message', messageHandel)
        return () => {
            props.worker.removeEventListener('message', messageHandel)
            versionRef.current = true
        }
    }, [])
    console.log('brand:', getBrand().slug)

    // Fetch Web Agent and Assets versions
    useEffect(() => {
        const fetchVersions = async () => {
            if (
                props.socketData?.socket &&
                props.socketData?.isAgentConnected
            ) {
                console.log('Fetching Web Agent and Assets versions...')

                // Get Web Agent version - try socket first, then HTTP fallback
                let agentVersion = await getWebAgentVersion(
                    props.socketData.socket
                )

                if (agentVersion) {
                    setWebAgentVersion(agentVersion)
                } else {
                    console.warn(
                        'Could not retrieve Web Agent version via socket or HTTP'
                    )
                }

                // Get Assets version
                const connectedDevice =
                    sessionStorage.getItem('connectedDevice')
                const deviceFolderMap = {
                    Humanoid: 'zing',
                    Hexapod: 'crawlee',
                    Ace: 'playcomputer',
                }
                const deviceFolder = deviceFolderMap[connectedDevice] || 'zing'

                const assets = await getAssetsVersion(
                    props.socketData.socket,
                    deviceFolder
                )
                if (assets) {
                    setAssetsVersion(assets)
                }
            }
        }

        fetchVersions()
    }, [props.socketData?.isAgentConnected, props.socketData?.socket])
    return (
        <div className={AdvanceSettingStyle.Main_Select}>
            <MainHeader
                title="About"
                titlePosition="left"
                help_btnPosition="right"
                // helper={<VisualPrgm />}
                isGoBack={false}
                showBluetoothBtn={true}
                goBack={() => {
                    history.goBack()
                }}
            />

            <div className={AdvanceSettingStyle.body}>
                <div
                    className={AdvanceSettingStyle.inner_body}
                    // style={{ backgroundColor: 'red' }}
                >
                    <img
                        src={
                            getBrand().slug === 'default'
                                ? renderImage('yuduRobotics')
                                : getLogo('company')
                        }
                        width="40%"
                        alt="Yudu Robotics"
                        style={{ marginBottom: '10vh' }}
                    />
                    <p>App Version : V{packageJson.version}</p>
                    {firmwareVersion && (
                        <>
                            <p>
                                Device Name : {grtDeviceName(firmwareVersion)} (
                                {getDeviceVersion(firmwareVersion)})
                            </p>
                            <p>Firmware Version : {firmwareVersion}</p>
                        </>
                    )}
                    {webAgentVersion && (
                        <p>PLODE Web Agent : V{webAgentVersion}</p>
                    )}
                    {assetsVersion && <p>Assets Version : V{assetsVersion}</p>}
                </div>
            </div>

            <div className={AdvanceSettingStyle.footer}>
                <p className={AdvanceSettingStyle.copyRightText}>
                    <span style={{ fontSize: '1.1rem' }}>&copy;</span>
                    {'  '}
                    {getLegalInfo().copyright_text}

                    {/* PLAYFULLY CRAFTED BY YUDU ROBOTICS */}
                </p>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        webserialPort: state.webSerial,
        worker: state.worker,
        device: state.device,
        deviceMismatch: state.deviceMismatch,
        isConnected: state.webSerial.isConnected,
        socketData: state.socketData,
    }
}

export default connect(mapStateToProps)(AboutApplication)
